import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { logger } from 'redux-logger';

import signerSagas from './sagas';
import modalReducer, { IModalState } from './reducers/modal';
import blockReducer, { IBlockState } from './reducers/blocks';
import zoomReducer, { IZoomState } from './reducers/zoom';
import envelopeReducer, { IEnvelopeState } from './reducers/envelope';
import groupReducer, { IGroupState } from './reducers/groups';
import signingExperienceReducer, { ISigningExperienceState } from './reducers/signingExperience';

import Server from '../resources/Server';
import { apiKey, accessToken } from '../index';

function* rootSaga(server: any) {
  yield all([fork(signerSagas, server)]);
}

const rootReducer = combineReducers({
  zoom: zoomReducer,
  modal: modalReducer,
  envelope: envelopeReducer,
  blocks: blockReducer,
  groups: groupReducer,
  signingExperience: signingExperienceReducer,
});

export interface IRootState {
  zoom: IZoomState;
  modal: IModalState;
  envelope: IEnvelopeState;
  blocks: IBlockState;
  groups: IGroupState;
  signingExperience: ISigningExperienceState;
}

export default function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const server = new Server(apiKey, accessToken);
  const middleware: any[] = [sagaMiddleware];
  if (process.env.NODE_ENV === 'development') {
    middleware.push(logger);
  }
  const enhancers = [applyMiddleware(...middleware)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable */

  const store = createStore(rootReducer, initialState, composeEnhancers(...enhancers));

  sagaMiddleware.run(rootSaga, server);
  return store;
}
